import { Component, ChangeDetectionStrategy, signal } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TenantService } from '../../../core/services/tenant.service';
import { CreateTenantRequest } from '../../../core/models/request/create-tenant-request';
import { switchMap, throwError } from 'rxjs';
import { CompanySettingsService } from '../../../core/services/company-settings.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-create-realm-dialog',
  templateUrl: './create-realm-dialog.component.html',
  styleUrls: ['./create-realm-dialog.component.scss'],
  providers: [TenantService, CompanySettingsService],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CreateRealmDialogComponent {
  settingsFormGroup = new FormGroup({
    realmAndTenantIdentifier: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required],
    }),
    displayName: new FormControl('', {
      nonNullable: true,
      validators: [Validators.required],
    }),
  });

  requiredErrorMessage = 'Dieses Feld darf nicht leer sein.';
  protected readonly isLoading = signal(false);

  constructor(
    private readonly tenantService: TenantService,
    private readonly companyService: CompanySettingsService,
    private readonly dialogRef: MatDialogRef<CreateRealmDialogComponent>,
  ) {}

  createRealmClicked() {
    if (this.settingsFormGroup.invalid) {
      this.settingsFormGroup.markAllAsTouched();
      return;
    }
    this.isLoading.set(true);
    const request: CreateTenantRequest = {
      identifier:
        this.settingsFormGroup.controls.realmAndTenantIdentifier.value,
      name: this.settingsFormGroup.controls.displayName.value,
    };

    this.tenantService
      .createNewTenant(request)
      .pipe(
        switchMap((tenant) => {
          if (!tenant.identifier)
            return throwError(
              () => new Error('Created tenant has no identifier.'),
            );
          return this.companyService
            .createInitialCompanySettings(tenant.identifier)
            .pipe(map(() => tenant));
        }),
      )
      .subscribe({
        next: (tenant) => {
          this.dialogRef.close(tenant.realmName);
        },
        error: () => {
          this.isLoading.set(false);
        },
      });
  }
}
